import GLightbox from 'glightbox';

export default class Gallery {
    constructor(element) {
        this.gallery = element
        this.galleryElements = this.gallery.querySelectorAll('.gallery-item')

        // Initialize Lightbox
        GLightbox({
            selector: '.gallery-item'
        });
    }
}